import { Link } from 'react-router-dom';
import type { Tarif } from '../billtoro/types';
import { fehlendeFunktion, planName, upgradeAnbieten } from '../billtoro/upgrade';
import { mahnungen } from './MahnlaufDaten';
import type { MahnlaufKurz } from './types';

// Hinweis auf die Mahnläufe über der Rechnungsliste und in der Übersicht (nur wenn eingeschaltet): heute fällig (nur
// vorschlagen; beim automatischen Senden gehen sie von selbst), Mahnungen, deren E-Mail nicht rausging, oder pausiert
// (Billtoro: der Tarif enthält sie nicht mehr; in der Übersicht gleich mit dem Tarif, der sie enthält).
export function MahnlaufHinweis({ mahnlauf, tarif, wo }: { mahnlauf: MahnlaufKurz | null | undefined; tarif?: Tarif | null; wo: 'liste' | 'uebersicht' }) {
  if (!mahnlauf?.an) return null;
  if (mahnlauf.pausiert) {
    const fehlt = fehlendeFunktion(tarif, 'mahnlauf');
    return (
      <div className="notice warn rt-ku">
        <span>Mahnläufe pausiert</span>
        {wo === 'uebersicht' && tarif && fehlt && fehlt !== 'bald' ? (
          <button type="button" className="btn small" onClick={() => upgradeAnbieten(tarif, 'mahnlauf')}>
            {planName(tarif, fehlt)} ansehen
          </button>
        ) : (
          <Link to="/rechnung/mahnlauf" className="btn small">
            Ansehen
          </Link>
        )}
      </div>
    );
  }
  return (
    <>
      {mahnlauf.probleme > 0 && (
        <div className="notice bad rt-ku">
          <span>{mahnungen(mahnlauf.probleme)} nicht per E-Mail verschickt</span>
          <Link to="/rechnung/mahnlauf" className="btn small">
            Prüfen
          </Link>
        </div>
      )}
      {mahnlauf.modus === 'vorschlagen' && mahnlauf.faellig > 0 && (
        <div className="notice warn rt-ku">
          <span>Heute fällig: {mahnungen(mahnlauf.faellig)}</span>
          <Link to="/rechnung/mahnlauf" className="btn small">
            Ansehen
          </Link>
        </div>
      )}
    </>
  );
}
